onComplete(function () {
	// Add code here.
	if (document.querySelector('.image-scroll-animation')) {
		gsap.to('.image-scroll-animation img', {
			clipPath: 'inset(0px 0px round 0px)',
			scrollTrigger: {
				trigger: '.image-scroll-animation',
				scrub: true,
				start: "top 40%",
				end: "center 55%",
			}
		});
	}

	// PERIOD END SENTENCE

	document.querySelectorAll("h1, h2, h3, .h3").forEach(el => {
    const text = el.textContent.trim();
		if (/[.?!]$/.test(text)) {
			const newHTML = text.replace(
				/([.?!])$/,
				'<span style="color: var(--primary);">$1</span>'
			);
			el.innerHTML = newHTML;
		}
	});

	// TIJDLIJN

	if (document.querySelector('section.horizontal-scroll')) {
		// document.querySelector('footer').classList.add('d-none');

		const scrollSection = document.querySelector('section.horizontal-scroll');
		let totalWidth = 0;
		document.querySelectorAll('section.horizontal-scroll > *').forEach((item) => {
			totalWidth += item.offsetWidth;
		})
		let horizontalScroll = gsap.to(scrollSection, {
			x: -totalWidth + window.innerWidth,
			ease: "none",
			scrollTrigger: {
				trigger: scrollSection,
				pin: true,
				scrub: true,
				end: "+=" + 1.25 * (totalWidth - window.innerWidth)
			}
		})

		let tl = gsap.timeline({
			scrollTrigger: {
				trigger: '.horizontal-scroll',
				start: "bottom bottom",
				toggleActions: "restart none resume reverse",
			}
		});

		tl.to('.tijdlijn-outer', {
			width: "100%",
		})
			.to('.jaar-inner', {
				y: 0,
				stagger: .05,
				duration: .5
			}, "<")

		let jaren = [];
		document.querySelectorAll('.jaar h2').forEach((jaar) => {
			jaren.push({
				"element": jaar,
				"text": jaar.innerText
			});
		})
		jaren.sort((a, b) => (a.text > b.text) ? 1 : -1);

		let jarenSorted = [];
		jaren.forEach((jaar) => {
			jarenSorted.push(jaar.element);
		});

		const tijdlijnJaren = document.querySelectorAll('.tijdlijn-jaar');
		const tijdlijnJaarWidth = tijdlijnJaren[0].getBoundingClientRect().width;
		const containerWidth = ((window.innerWidth - document.querySelector('main .container').offsetWidth) / 2) + 15;
		let timelineInnerWidth = 0;

		jarenSorted.forEach((jaar, i) => {
			gsap.to('.tijdlijn-inner', {
				scrollTrigger: {
					trigger: jaar,
					start: "right right",
					end: "left center",
					toggleActions: "play none none none",
					containerAnimation: horizontalScroll,
					onUpdate: () => {
						jarenSorted.forEach((jaar, i) => {
							jaar.classList.remove('active');
							tijdlijnJaren[i].classList.remove('active');
						})
						jaar.classList.add('active');
						tijdlijnJaren[i].classList.add('active');
						timelineInnerWidth = tijdlijnJaren[i].getBoundingClientRect().left + tijdlijnJaarWidth - containerWidth;
						gsap.to('.tijdlijn-inner', {
							x: timelineInnerWidth,
						})
					}
				},
			})
		})
	}
});